.dialog {
  min-height: 80vh;
  min-width: 300px;
}

.progress {
  margin-top: 32px;
}

.content {
  flex: 1;
}

.actionButton {
  margin-right: 8px;
}
